import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const BEST_SCORE_KEY = 'hockey_rush_best';

function loadBest() {
    try {
        const raw = localStorage.getItem(BEST_SCORE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

function saveBest(score) {
    try {
        const prev = loadBest();
        const isNew = !prev
            || score.player > prev.player
            || (score.player === prev.player && score.ai < prev.ai);
        if (isNew) localStorage.setItem(BEST_SCORE_KEY, JSON.stringify(score));
        return isNew;
    } catch { return false; }
}

function starCount(player, ai) {
    if (player > ai) return 3;
    if (player === ai) return 2;
    return 1;
}

export function GameOverScreen({ score, onPlayAgain }) {
    const stars = starCount(score.player, score.ai);
    const [isNewBest, setIsNewBest] = useState(false);
    const [prevBest,  setPrevBest]  = useState(null);
    const [shareLabel, setShareLabel] = useState('Share Result');

    useEffect(() => {
        const prev = loadBest();
        setPrevBest(prev);
        const newBest = saveBest(score);
        setIsNewBest(newBest);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const resultMsg = stars === 3
        ? '¡Victory! Legendary performance!'
        : stars === 2
            ? "A hard-fought draw. Can you win next time?"
            : 'Defeat. The team needs you — play again!';

    const handleShare = async () => {
        const starStr = '★'.repeat(stars) + '☆'.repeat(3 - stars);
        const text = `Hockey Rush: YOU ${score.player}–${score.ai} AI  ${starStr}`;
        if (navigator.share) {
            try { await navigator.share({ title: 'Hockey Rush', text }); } catch {}
        } else {
            try {
                await navigator.clipboard.writeText(text);
                setShareLabel('Copied!');
                setTimeout(() => setShareLabel('Share Result'), 2000);
            } catch {
                setShareLabel(text);
            }
        }
    };

    return (
        <div className="arcade-overlay-screen">
            <div className="overlay-card">
                <h2 className="overlay-title">Full Time</h2>

                <div className="overlay-score">
                    <div className="overlay-score-block player">
                        <span className="overlay-score-num">{score.player}</span>
                        <span className="overlay-score-label">YOU</span>
                    </div>
                    <span className="overlay-score-dash">—</span>
                    <div className="overlay-score-block ai">
                        <span className="overlay-score-num">{score.ai}</span>
                        <span className="overlay-score-label">AI</span>
                    </div>
                </div>

                <div className="overlay-stars">
                    {[1, 2, 3].map(i => (
                        <span key={i} className={i <= stars ? 'star active' : 'star'}>★</span>
                    ))}
                </div>

                {isNewBest && (
                    <p className="overlay-new-best">New best!</p>
                )}
                {!isNewBest && prevBest && (
                    <p className="overlay-best">Best: {prevBest.player}–{prevBest.ai}</p>
                )}

                <p className="overlay-message">{resultMsg}</p>

                <button className="overlay-btn" onClick={onPlayAgain}>Play Again</button>
                <button className="overlay-btn overlay-btn--share" onClick={handleShare}>
                    {shareLabel}
                </button>
                <Link to="/" className="overlay-link">Back to menu</Link>
            </div>
        </div>
    );
}
